import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment/moment';
import PropTypes from 'prop-types';

import useUser from 'core/hooks/useUser';
import Modal from 'core/ui/components/V2/ModalV2';
import { Flex, Text, Button } from 'core/ui/atoms';
import { WeekContainer } from 'onramp/ui/components';

const CancelModal = ({
  closeModal,
  handleSubmit,
}) => {
  const [selectConfirm, setSelectConfirm] = useState(false);
    const { currentUser } = useUser();
    const nextCutoffTime = moment(currentUser?.nextDeliveryOrderDate).format('dddd, MMMM Do');

  return (
    <Modal
      title='Edit My Subscription'
      data-account-info-modal
      onClose={closeModal}
      fullWidth={true}
    >
      <ModalTitle>Edit My Subscription</ModalTitle>
      <WeekContainer>Signature Program</WeekContainer>
      <Description>
        Cancel your subscription if you don't plan to return to this program.
      </Description>
      {nextCutoffTime &&
        <Description>
          Your last locked order will be delivered on {nextCutoffTime}.
          Please note that all order edits or cancellations must be made by Sunday at 9:00 PM PT,
          one week prior to your scheduled delivery.
        </Description>
      }
      <ButtonContainer direction='column' justifyContent='center' alignItems='center'>
        <ButtonStyle
          btn-outline
          $selectConfirm={selectConfirm}
          onClick={() => setSelectConfirm(!selectConfirm)}>
          CANCEL MY SUBSCRIPTION
        </ButtonStyle>
        <ConfirmBtn
          btn-primary
          $selectConfirm={selectConfirm}
          disabled={!selectConfirm}
          onClick={handleSubmit}>
          CONFIRM
        </ConfirmBtn>
      </ButtonContainer>
    </Modal>
  );
};

CancelModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const Description = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${({ theme }) => theme.colors.darkGreen};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ButtonContainer = styled(Flex)`
  margin-top: 20px;
  width: 100%;
  padding-left: 50px;
  padding-right: 50px;
  gap: 20px;
`;

const ConfirmBtn = styled(Button)`
  width: 100%;
  margin-bottom: 10px;
  padding: 13px 32px;
  border-radius: 4px;
  background: #36443A;
`;

const ButtonStyle = styled(Button)`
  width: 100%;
  height: 43px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.darkGreen};
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 23px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  &:hover {
    background: ${({ $selectConfirm }) => $selectConfirm ? '#C5D1C0' : 'none'};
    color: ${({ theme, $selectConfirm }) => $selectConfirm ? '#36443A' : theme.colors.darkGreen};
  }
`;

const ModalTitle = styled(Text)`
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.9px;
  margin-top: 100px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
  color: ${({ theme }) => theme.colors.darkGreen};
`;

export default CancelModal;
